
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import charmhealthlogo_placeholder from '../../../assets/charmhealthlogo_placeholder.jpg';
import { buttonLabels } from '../../../Constants/Data'

const AddOn = ({ id, thumbnail, name, description, categories, vendor_id, vendor_name, expanded }) => {
    const navigate = useNavigate();

    const handleProductNameClick = (productName, productID) => {
        const url = generateProductLink(productName, productID);
        navigate(url);
    };

    const generateProductLink = (name, id) => {
        return `/explore/${id}`;
    };

    const [dataLayer, setDataLayer] = useState([]);

    useEffect(() => {
        setDataLayer(window.dataLayer);
    }, []);

    const pushToDataLayer = (data) => {
        window.dataLayer.push(data);
    }

    const handleClick = (navigateTo) => {
        const data = {
            event: 'product_click',
            product_name: name,
            product_category: categories.join(', '),
            product_vendor_id: vendor_id,
            product_vendor_name: vendor_name,
            product_id: id,
        };

        pushToDataLayer(data);
        navigate(`/explore/${id}`)
        // window.location.href = navigateTo;
    };

    const getCategoryLabel = (categoryNumber) => {
        const category = buttonLabels.find(btn => btn.number === parseInt(categoryNumber));
        return category ? category.label : categoryNumber.toString();
    };

    const getCategoryColor = (categoryNumber) => {
        const category = buttonLabels.find(btn => btn.number === parseInt(categoryNumber));
        return category ? category.background : categoryNumber.toString();
    };


    return (
        <div className={`w-full h-fit flex flex-col bg-white p-[20px]`}>
            <div className="w-full h-[100px] md:h-24 xl:h-32 flex flex-row">
                <div className="w-[100px] h-[100px] md:w-24 md:h-24 xl:w-32 xl:h-32 flex-shrink-0 flex flex-row justify-between">
                    <img
                        src={
                            thumbnail
                                ? thumbnail
                                : charmhealthlogo_placeholder
                        }
                        alt={`${name} logo`}
                        className={'object-contain' + (thumbnail && thumbnail.includes('.amazonaws.com') ? '' : 'border-2 border-lightNeutral')}
                        onClick={() => handleProductNameClick(name, id)}
                    />
                </div>
                <div className="flex flex-grow items-center mx-3">
                    <h5
                        className="text-left text-[26px] font-bold font-proximanova overflow-hidden line-clamp-2"
                        onClick={() => handleProductNameClick(name, id)}
                    >
                        {name}
                    </h5>
                </div>
            </div>

            <div className="mt-[12px] flex flex-row overflow-x-auto scrollbar-hide space-x-2">
            {categories
                    .filter(category => category !== "6")
                    .map((category, index) => (
                    <div key={index} className="w-fit rounded-full text-[#5f5f5f] px-3 py-0.5 text-[12px] whitespace-nowrap scrollbar-hide"
                        style={{ backgroundColor: getCategoryColor(category) }}
                    >
                        {getCategoryLabel(category)}
                    </div>
                ))}
            </div>

            <div className="mt-[12px] h-[72px] text-left text-[18px] line-clamp-3 font-proximanova" style={{ lineHeight: '1.35' }}>
                {description}
            </div>

            <div className="mt-[12px] flex flex-row justify-between">
                <button
                    onClick={() => handleClick(`/explore/${id}`)}
                    className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                >
                    Find out more
                </button>

                {/* <button className="text-link italic underline text-md md:text-lg xl:text-xl font-semibold hover:text-integrationRequestTextHover w-fit">
                    Submit Request
                </button> */}
            </div>
        </div>

    );
}

export default AddOn;